import React from 'react';
export const lowercaseConjunction = title => {
  const conjunctions = ['and', 'to', 'on'];
  const words = title.split(/(\s+|\(|\))/);
  const modifiedWords = words.map((word, index) => {
    if (conjunctions.includes(word)) {
      return /*#__PURE__*/React.createElement("span", null, word);
    }
    if (index === words.length - 1) {
      return word;
    }
    return `${word}`;
  });
  return modifiedWords;
};